import SEO from "@/components/SEO";
import { Reveal, GoldRule } from "@/components/Shared";
import { HairHero, HairBreadcrumb, HairBand, HairEyebrow, HairHeading, HairCard, NumberedColumns, CandidacyBand, HairCTABand } from "@/components/HairShared";
import { StickyCTA } from "@/components/Landing";
import { OFFERS } from "@/data/landing";
import { HAIR_LOSS_HUB, HAIR_LOSS_CARDS, HAIR_BREADCRUMBS, HAIR_HERO } from "@/data/hair";

const HairLossHub = () => {
  const crumbs = HAIR_BREADCRUMBS.hairLoss();
  return (
    <>
      <SEO
        title={HAIR_LOSS_HUB.seoTitle}
        description={HAIR_LOSS_HUB.seoDescription}
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: crumbs.map((c, i) => ({ "@type": "ListItem", position: i + 1, name: c.name, item: `https://www.lumiereaesthetics.com.au${c.to}` })),
        }}
      />
      <HairHero eyebrow={HAIR_LOSS_HUB.eyebrow} title={HAIR_LOSS_HUB.h1} standfirst={HAIR_LOSS_HUB.standfirst} offer={OFFERS.hair} image={HAIR_HERO.roomDetail} tall={false} testId="hair-loss-hero" />
      <HairBreadcrumb items={crumbs} />

      <HairBand testId="hair-loss-grid-section">
        <Reveal className="mb-12">
          <HairEyebrow className="mb-3">Six patterns</HairEyebrow>
          <HairHeading>What is happening — and what can honestly be done.</HairHeading>
          <GoldRule className="mt-6" />
        </Reveal>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="hair-loss-grid">
          {HAIR_LOSS_CARDS.map((card, i) => (
            <Reveal key={card.to} delay={(i % 3) * 0.08}>
              <HairCard to={card.to} title={card.title} text={card.text} testId={`hair-loss-card-${card.slug}`} />
            </Reveal>
          ))}
        </div>
      </HairBand>

      <HairBand dark testId="hair-loss-sequence">
        <Reveal className="mb-12">
          <HairEyebrow className="mb-3">The order</HairEyebrow>
          <HairHeading dark>{HAIR_LOSS_HUB.sequence.heading}</HairHeading>
          <p className="text-warm-white/80 mt-6 max-w-2xl leading-[1.8]">{HAIR_LOSS_HUB.sequence.intro}</p>
        </Reveal>
        <NumberedColumns items={HAIR_LOSS_HUB.sequence.steps} dark testId="hair-loss-steps" />
      </HairBand>

      <CandidacyBand />
      <StickyCTA practitioner="Dr Kristy Truong" hair />
      <HairCTABand />
    </>
  );
};

export default HairLossHub;
